import { ConfirmationModal } from "components/Modal";
import { ChakraText } from "components/ChakraText";

import { useCancelUserAppointment } from "../../infrastructure/useCancelUserAppointment";
import { useCancelUserAppointmentNotification } from "./useCancelUserAppointmentNotification";

interface IProps {
  onClose: () => void;
  isOpen: boolean;
  appointmentId: string;
  onSuccess?: () => void;
}

const CancelationUserAppointmentModal = ({
  appointmentId,
  isOpen,
  onClose,
  onSuccess,
}: IProps) => {
  const mutation = useCancelUserAppointment();
  const {
    showSuccessNotification,
    showErrorNotification,
  } = useCancelUserAppointmentNotification();
  return (
    <ConfirmationModal
      onClose={onClose}
      isOpen={isOpen}
      onAccept={async () => {
        try {
          await mutation.mutateAsync(appointmentId);
          showSuccessNotification();
          onSuccess && onSuccess();
        } catch {
          showErrorNotification();
        }
        onClose();
      }}
      modalBody={<ChakraText>Czy na pewno chcesz anulować wizytę?</ChakraText>}
      isLoading={mutation.isLoading}
    />
  );
};

export { CancelationUserAppointmentModal };
